import React from "react";

import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import styled from "@emotion/styled";
const WrapperAccordian = styled.div`
  /* border-bottom: 1px solid #fff; */
  margin: 20px 0;
  padding: 15px 0;
  max-width: 90%;
  background-color: #000;
  color: #fff;
  @media screen and (max-width:899px){
    /* max-width: 70%; */
  }
  @media screen and (max-width:599px){
    max-width: 100%;
    
  }
`;
const Div = styled.div`
text-align: -moz-center;
text-align: -webkit-center;
`;
const AccordianMain = () => {
  return (
    <Div  >
      <WrapperAccordian>
        <AccordionSummary>
          <Typography sx={{ textAlign: "left", fontWeight: "bold", textTransfom: "uppercase", width: "100%", flexShrink: 0 }}>
           - Create a MetaMask wallet to store ERC-20 tokens securely.
          </Typography>
        </AccordionSummary>
      </WrapperAccordian>
      <WrapperAccordian>
        <AccordionSummary>
          <Typography sx={{ textAlign: "left", fontWeight: "bold", width: "100%", flexShrink: 0 }}>
          - Send Ethereum (ETH) to your MetaMask wallet.
          </Typography>
        </AccordionSummary>
      </WrapperAccordian>
      <WrapperAccordian>
        <AccordionSummary>
          <Typography sx={{ textAlign: "left", fontWeight: "bold", width: "100%", flexShrink: 0 }}>
          - Visit Uniswap and access the $PehPeh token trading page.
          </Typography>
        </AccordionSummary>
      </WrapperAccordian>
      <WrapperAccordian>
        <AccordionSummary  >
          <Typography sx={{ textAlign: "left", fontWeight: "bold", width: "100%", flexShrink: 0 }}>
          - Swap your ETH for $PehPeh tokens on Uniswap's platform.
          </Typography>
        </AccordionSummary>
      </WrapperAccordian>

    </Div>
  );
};

export default AccordianMain;
